'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;

exports.averageOverInterval = averageOverInterval;

function averageOverInterval(context, config, next) {
    var divisor = $u.generic.getAverageDivisor(context.durationFilterValue, context.granularity);

    _.forEach(context.apiParsedResponseList, function (responseElement) {
        _.forEach(context.fields, function (field) {
            if (!_.find(context.rejectFields, function (elem) {
                  return elem === field;
              })) {
                responseElement[field] = _.map(responseElement[field], function (elem) {
                    return elem === null ? null : Math.round(elem / divisor);
                });
            }
        });
    });
    next();
}